import { getGridSummaryCount, renderGridSummarySum, renderGridSummarySumTonnes, renderGridSummarySumHL } from 'components/global/utils';
import { SkuDistrictReportGridData } from '@pages/reporting-pages/deliveries-sku-district/types/SkuDistrictReportGridData';



interface GridSummaryProps<T> {
	data?: T[] | null,
}


const GridSummary = (props: GridSummaryProps<SkuDistrictReportGridData>) => {
	const { data } = props;

	return (
		<>
			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
				<p>{getGridSummaryCount(data)}</p>
			</div>


			<div className='app-grid-summary'>
				<p>{renderGridSummarySumHL(data, 'total_volume')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumTonnes(data, 'total_weight')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySum(data, 'total_ordersCount')}</p>
			</div>
		</>
	)
}

export default GridSummary;